import Image from 'next/image';
import {
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
  EmailShareButton
} from 'next-share';

interface IconLinkProps {
  href: string;
  label: string;
  icon: string;
  width: number;
  height: number;
}

const IconLink = ({ label, icon, width, height }: IconLinkProps) => (
  <Image src={`/icons/${icon}.svg`} width={width} height={height} alt={label} />
);

const SocialShare = ({ slug }: { slug: string }) => {
  function generateURL(source: string) {
    return `https://dailypolished.com/blog/${slug}?utm_content=socialbutton&utm_medium=social&utm_source=${source}`;
  }

  return (
    <>
      <FacebookShareButton url={generateURL('facebook')}>
        <IconLink
          href="#"
          label="Facebook"
          icon="facebook-gray"
          width={8}
          height={12}
        />
      </FacebookShareButton>
      <PinterestShareButton url={generateURL('pinterest')} media="#">
        <IconLink
          href="#"
          label="Pinterest"
          icon="pinterest"
          width={14}
          height={14}
        />
      </PinterestShareButton>
      <TwitterShareButton url={generateURL('twitter')}>
        <IconLink
          href="#"
          label="Twitter"
          icon="twitter-gray"
          width={14}
          height={14}
        />
      </TwitterShareButton>
      <EmailShareButton url={generateURL('email')}>
        <IconLink
          href="#"
          label="Email"
          icon="email-gray"
          width={14}
          height={14}
        />
      </EmailShareButton>
    </>
  );
};

export default SocialShare;
